import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import { AppStoreHomeProvider } from '../../features/apps/context/AppStoreHomeContext';
import ChatShell from '../../features/apps/components/ChatShell';

// Layout route for /chat, /apps, and /cases. Bottom nav is the shared
// black/white Sidebar footer; ChatShell only owns the pane swap and puts
// the chat tab's query back when the user returns to /chat.
export default function ChatRoute() {
  return (
    <ProtectedRoute requiresAuth={true}>
      <AppStoreHomeProvider>
        <ChatShell />
      </AppStoreHomeProvider>
    </ProtectedRoute>
  );
}
